import { render, staticRenderFns } from "./SortLi.vue?vue&type=template&id=fc2b5ac2&scoped=true"
import script from "./SortLi.vue?vue&type=script&lang=js"
export * from "./SortLi.vue?vue&type=script&lang=js"
import style0 from "./SortLi.vue?vue&type=style&index=0&id=fc2b5ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2b5ac2",
  null
  
)

export default component.exports